import React, { useEffect, useState } from "react";
import AceEditor from "react-ace";
import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-dawn";
import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import { useDispatch } from "react-redux";
import { Label } from "@atlaskit/form";
import ScriptVariableHint from "./ScriptVariableHint";
import { getAceEditorTheme } from "../../../../../../../common/utils/aceEditorTheme";

const ScriptEditor = ({ script, onChange }) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(script);

  useEffect(() => {
    // Update the editor value when the script prop changes
    setValue(script);
  }, [script, value]);

  const onChangeScript = (e) => {
    setValue(e);
    onChange(e);
    dispatch(setEditorSaved(false));
  };

  return (
    <div className="stack-container">
      <Label>Script:</Label>
      <AceEditor
        className="stack-item"
        mode="javascript"
        theme={getAceEditorTheme()}
        name="code"
        editorProps={{ $blockScrolling: true }}
        value={value}
        onChange={onChangeScript}
        height="300px"
        width="100%"
        showPrintMargin={false}
      />
      <ScriptVariableHint />
      <p>
        <b>Note:</b> The script must <b>return</b> an <b>object</b>, which can
        then be used by its child actions to adjust or transmit the data.
      </p>
      <span>
        Scripted actions are a flexible step in an integration flow that uses
        JavaScript to process data from earlier actions or the trigger itself.
        Similar to data transformation in ETL (Extract, Transform, Load)
        processes, this action allows you to filter, modify, or combine data as
        needed.
      </span>
    </div>
  );
};

export default ScriptEditor;
